/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import './index.scss';
import { Table, Icon, Dropdown, Popup } from 'semantic-ui-react';
import formatNumber from 'helpers/formatNumber';
import capitalize from 'utils/capitalize';
import Thumbnail from 'components/common/Thumbnail';
import RequestPopupContent, {
  getStatusColor,
} from 'containers/Organizations/SingleOrganization/Profiles/SingleProfile/Requests/SingleRequest/RequestPopupContent';

const LoanRequestTable = ({ items }) => {
  const { push } = useHistory();

  const {
    details: { roles },
  } = useSelector(({ user: { currentUser } }) => currentUser);

  const params = useParams();

  const isSaAdmin = roles.some(role => role.name === 'sa_admin');
  const isSupportAdmin = roles.some(
    role => role.name === 'sa_support_admin',
  );
  const isLoanAdmin = roles.some(role => role.name === 'loan_admin');
  const hasMicroloanPermission =
    isSaAdmin || isSupportAdmin || isLoanAdmin;

  return (
    <>
      <div className="list-loan-requests__items__table">
        <Table basic="very" size="small" textAlign="left">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="">Group</Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                Micro-loan type
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                <span>
                  Requested amount{' '}
                  <span className="table-data__currency">(RWF)</span>
                </span>
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                Repayment Days
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                <span>
                  Interest on Loan{' '}
                  <span className="table-data__currency">(RWF)</span>
                </span>
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                <span>
                  Outstanding Loan{' '}
                  <span className="table-data__currency">(RWF)</span>
                </span>
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                Loan reason
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                Expiration Date
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data">
                Status
              </Table.HeaderCell>
              <Table.HeaderCell className="table-data" width="1">
                Action
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body
            className={`list-loan-requests__items__table__tbody wallet__transactions--table-body ${true &&
              'lg-tbody'}`}
          >
            {items.map(request => {
              return (
                <Table.Row
                  key={request.id}
                  className="table-row cursor"
                >
                  <Table.Cell
                    className="wallet__transactions--originator"
                    onClick={() =>
                      hasMicroloanPermission &&
                      push(
                        `/organizations/${params?.organizationId}/requests/${request?.id}`,
                      )
                    }
                  >
                    <Thumbnail name={request?.group?.name} />
                    <div>
                      <span>{request?.group?.name}</span>
                      <div style={{ fontSize: 10 }}>
                        <b>Profile: </b>
                        <span>
                          {request?.group?.loan_profile_monthly?.[0]
                            ?.loan_profile?.name || 'No profile'}
                        </span>
                      </div>
                    </div>
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {capitalize(request?.type?.replace(/_/g, ' '))}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {formatNumber(request.amount)}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {formatNumber(request.repayment_days)}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {formatNumber(request.loans_interest)}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {formatNumber(request.loans_balance)}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {capitalize(request.purpose)}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    {request?.expiration_date
                      ? moment(request.expiration_date).format(
                          'MMM DD, YYYY',
                        )
                      : '-'}
                  </Table.Cell>
                  <Table.Cell className="table-data">
                    <div
                      className="status-dot"
                      style={{
                        backgroundColor: getStatusColor(
                          request.status,
                        ),
                      }}
                    />
                    {capitalize(request.status)}
                  </Table.Cell>
                  <Table.Cell className="table-data" width="1">
                    <div className="flex flex-between flex-center-vertical">
                      <span className="more-info">
                        <Popup
                          trigger={
                            <div style={{ color: '#2185D0' }}>
                              <Icon
                                name="info circle"
                                color="#2185D0"
                                className="info-icon"
                              />
                              <u>info</u>
                            </div>
                          }
                          content={
                            <RequestPopupContent request={request} />
                          }
                          hoverable
                          position="left center"
                          on="click"
                          pinned
                        />
                      </span>
                      {hasMicroloanPermission && (
                        <Dropdown
                          icon={null}
                          direction="left"
                          trigger={
                            <div className="action-icon">
                              <Icon name="ellipsis vertical" />
                            </div>
                          }
                        >
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                push(
                                  `/organizations/${params?.organizationId}/requests/${request?.id}`,
                                );
                              }}
                            >
                              View
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

LoanRequestTable.defaultProps = {
  items: [],
};

LoanRequestTable.propTypes = {
  items: PropTypes.array,
};

export default LoanRequestTable;
